import { Topic } from '@/core/notifications/model';
import ScopeSummary from './scope-summary';

// Last screen of the per-field scope flow: a review of every field's chosen
// scope before moving on to delivery, each with a jump-back to that one
// field's own step — the wizard's own use of the same ScopeSummary a
// preloaded flow shows in Step 3. Editing a field and finishing it returns
// straight back here (see goToFieldForEdit/finishEditingField in the wizard's
// state hook), not through every other field first.
export default function StepScopeConfirm({
  topic,
  tagValues,
  scopeModeByField,
  onEditField,
}: {
  topic: Topic | undefined;
  tagValues: Record<string, string[]>;
  scopeModeByField: Record<string, 'all' | 'narrow'>;
  onEditField: (tagKey: string) => void;
}) {
  return (
    <div>
      <div className="mutedText mb-3" style={{ fontSize: 13 }}>
        Review the scope of this alarm before choosing where to deliver it.
      </div>
      <ScopeSummary
        topic={topic}
        tagValues={tagValues}
        scopeModeByField={scopeModeByField}
        onEditField={onEditField}
      />
    </div>
  );
}
